import request from '@/api/request';

export function sessionRemove() {
    return request.post('/postlogin/session/remove', {});
}

